import { Calculation } from 'src/admin-entity/interface/calculation/calculation.interface';

import { BASE_URL } from 'src/config/api';
import { AxiosResponse } from 'axios';
import { TaxStatus } from 'src/admin-entity/enum/product/tax-status.enum';
import { format } from 'date-fns';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { ExcelDownloadSummary } from 'src/admin-entity/interface/excel/excel-download-summary.interface';
import { noTimeoutClient } from '../client';

export const getCalculation = (
    page: number,
    take: number,
    beginDate: string,
    endDate: string,
    taxStatus: TaxStatus,
    distributorId: number,
    searchType: string,
): Promise<AxiosResponse<Page<Calculation>>> => {
    return noTimeoutClient.get(
        `${BASE_URL}/v1/admin/settlement?page=${page}&take=${take}&beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            taxStatus === 'tax-all' ? `` : `&taxStatus=${taxStatus}`
        }${distributorId === 0 ? `` : `&distributorId=${distributorId}`}&searchType=${searchType}`,
    );
};

export const getCalculationSummary = (
    page: number,
    take: number,
    beginDate: string,
    endDate: string,
    taxStatus: TaxStatus,
    distributorId: number,
    searchType: string,
): Promise<AxiosResponse<Calculation>> => {
    return noTimeoutClient.get(
        `${BASE_URL}/v1/admin/settlement/all-summary?page=${page}&take=${take}&beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            taxStatus === 'tax-all' ? `` : `&taxStatus=${taxStatus}`
        }${distributorId === 0 ? `` : `&distributorId=${distributorId}`}&searchType=${searchType}`,
    );
};

export const getCalculationExcelSummary = (
    beginDate: string,
    endDate: string,
    taxStatus: TaxStatus,
    searchType: string,
): Promise<AxiosResponse<ExcelDownloadSummary>> => {
    return noTimeoutClient.post(
        `${BASE_URL}/v1/admin/settlement/excel/summary?beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            taxStatus === 'tax-all' ? `` : `&taxStatus=${taxStatus}`
        }&searchType=${searchType}`,
    );
};

export const getCalculationExcelSummaryDetail = (
    beginDate: string,
    endDate: string,
    taxStatus: TaxStatus,
    distributorIds: number[],
    searchType: string,
): Promise<AxiosResponse<ExcelDownloadSummary>> => {
    return noTimeoutClient.post(
        `${BASE_URL}/v1/admin/settlement/excel/detail?beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            taxStatus === 'tax-all' ? `` : `&taxStatus=${taxStatus}`
        }&searchType=${searchType}`,
        distributorIds,
    );
};
